// Plantilla del correo que recibe el equipo cuando alguien llena el formulario de contacto.
// Los clientes de correo (Gmail, Outlook) solo respetan tablas y estilos en línea, por eso no usa clases.
// Todo lo que escribe el visitante se escapa: nunca se inserta HTML del formulario sin pasar por `escapar`.

const escapar = (texto = '') => String(texto)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const COLOR = {
    tinta: '#0b1f3f',
    texto: '#566176',
    suave: '#8591a5',
    linea: '#e3e9f3',
    fondo: '#eff5fe',
    lila: '#e6f0fe',
    acento: '#1466d8',
};

const fila = (etiqueta, valorHtml) => `
    <tr>
        <td style="padding:12px 0;border-bottom:1px solid ${COLOR.linea};width:110px;vertical-align:top;color:${COLOR.suave};font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;">${etiqueta}</td>
        <td style="padding:12px 0;border-bottom:1px solid ${COLOR.linea};vertical-align:top;color:${COLOR.tinta};font-size:15px;">${valorHtml}</td>
    </tr>`;

export const correoContactoHtml = ({ nombre, email, telefono, asunto, mensaje, fecha }) => {
    const telefonoLimpio = String(telefono).replace(/[^\d+]/g, '');
    const fechaTexto = fecha.toLocaleString('es-MX', { dateStyle: 'long', timeStyle: 'short', timeZone: 'America/Mexico_City' });
    return `<!doctype html>
<html lang="es">
<head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>Nuevo mensaje de contacto</title></head>
<body style="margin:0;padding:0;background:${COLOR.fondo};font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;">
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:${COLOR.fondo};padding:32px 12px;">
<tr><td align="center">
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;background:#ffffff;border-radius:20px;overflow:hidden;border:1px solid ${COLOR.linea};">
        <tr>
            <td style="background:${COLOR.tinta};background-image:linear-gradient(135deg,#0b2a6b 0%,#1877f2 100%);padding:28px 32px;">
                <div style="display:inline-block;padding:4px 12px;border-radius:999px;background:rgba(255,255,255,0.16);color:#ffffff;font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;">reditmex.com · Contacto</div>
                <h1 style="margin:14px 0 4px;color:#ffffff;font-size:24px;line-height:1.25;font-weight:700;">Nuevo mensaje de ${escapar(nombre)}</h1>
                <p style="margin:0;color:rgba(255,255,255,0.8);font-size:14px;">${escapar(fechaTexto)}</p>
            </td>
        </tr>
        <tr>
            <td style="padding:28px 32px 8px;">
                <p style="margin:0 0 6px;color:${COLOR.suave};font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;">Asunto</p>
                <p style="margin:0 0 20px;color:${COLOR.tinta};font-size:18px;font-weight:700;">${escapar(asunto)}</p>
                <div style="padding:18px 20px;border-radius:14px;background:${COLOR.fondo};border-left:4px solid ${COLOR.acento};color:${COLOR.tinta};font-size:15px;line-height:1.6;white-space:pre-wrap;">${escapar(mensaje)}</div>
            </td>
        </tr>
        <tr>
            <td style="padding:12px 32px 8px;">
                <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                    ${fila('Nombre', escapar(nombre))}
                    ${fila('Email', `<a href="mailto:${escapar(email)}" style="color:${COLOR.acento};text-decoration:none;font-weight:600;">${escapar(email)}</a>`)}
                    ${fila('Teléfono', `<a href="tel:${escapar(telefonoLimpio)}" style="color:${COLOR.acento};text-decoration:none;font-weight:600;">${escapar(telefono)}</a>`)}
                </table>
            </td>
        </tr>
        <tr>
            <td style="padding:20px 32px 28px;">
                <a href="mailto:${escapar(email)}?subject=${encodeURIComponent('Re: ' + asunto)}" style="display:inline-block;padding:12px 20px;border-radius:12px;background:${COLOR.tinta};color:#ffffff;font-size:14px;font-weight:600;text-decoration:none;">Responder por correo &rarr;</a>
                <a href="https://wa.me/${escapar(telefonoLimpio.replace(/^\+/, ''))}" style="display:inline-block;margin-left:8px;padding:12px 20px;border-radius:12px;background:${COLOR.lila};color:${COLOR.tinta};font-size:14px;font-weight:600;text-decoration:none;">WhatsApp</a>
            </td>
        </tr>
        <tr>
            <td style="padding:18px 32px;border-top:1px solid ${COLOR.linea};color:${COLOR.suave};font-size:12px;line-height:1.5;">
                Te recomendamos contestarle lo más pronto posible.<br>
                Este correo se generó automáticamente desde el formulario de <a href="https://www.reditmex.com/contacto" style="color:${COLOR.acento};text-decoration:none;">www.reditmex.com/contacto</a>.
            </td>
        </tr>
    </table>
</td></tr>
</table>
</body>
</html>`;
};

// Versión en texto plano para clientes que no muestran HTML
export const correoContactoTexto = ({ nombre, email, telefono, asunto, mensaje, fecha }) => [
    'Nuevo mensaje desde el formulario de contacto de www.reditmex.com',
    fecha.toLocaleString('es-MX', { dateStyle: 'long', timeStyle: 'short', timeZone: 'America/Mexico_City' }),
    '',
    `Asunto: ${asunto}`,
    `Nombre: ${nombre}`,
    `Email: ${email}`,
    `Teléfono: ${telefono}`,
    '',
    'Mensaje:',
    mensaje,
    '',
    'Te recomendamos contestarle lo más pronto posible.',
].join('\n');
